import gql from "graphql-tag";

export default gql`
  query humidityMeasurementsTable($fromDateTime: DateTime!, $toDateTime: DateTime!) {
    humidityMeasurementsTable(fromDatetime: $fromDateTime, toDatetime: $toDateTime)
  }
`;
